export const BIO_MAX_LENGTH = 30;
export const SLOGAN_MAX_LENGTH = 40;
export const DISPLAY_NAME_SHORT_MAX_LENGTH = 50;
export const FIRST_NAME_MAX_LENGTH = 50;
export const LAST_NAME_MAX_LENGTH = 50;
export const TOPIC_MAX_LENGTH = 50;
